<template>
  <th class="text-center">
    <div
      @click="handleSortStrategy"
      class="transaction-sort-title small-container"
    >
      <span>{{ label }}</span>
      <em :class="sortIconStyle()"></em>
    </div>
  </th>
</template>

<script>
export default {
  name: 'sortableTh',
  props: {
    property: {
      type: String,
      required: true,
      default: '',
    },
    label: {
      type: String,
      required: true,
      default: '',
    },
    sortProperty: {
      type: String,
      required: true,
      default: '',
    },
    sortToggle: {
      type: Number,
      required: true,
      default: '',
    },
  },
  methods: {
    handleSortStrategy() {
      this.$emit('handleSortStrategy', this.property);
    },
    sortIconStyle() {
      if (this.property === this.sortProperty) {
        return `fa fa-sort-${this.sortToggle === 1 ? 'asc' : 'desc'}`;
      }
      return 'fa fa-sort';
    },
  },
};
</script>

<style scoped>
.transaction-sort-title {
  display: flex;
  align-items: center;
  user-select: none;
}

.transaction-sort-title:hover {
  cursor: pointer;
}

.fa {
  padding-left: 10px;
  margin-top: auto;
  margin-bottom: 3px;
}

.small-container {
  justify-content: center;
}

.large-container {
  justify-content: flex-end;
}

.large-container .fa {
  margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// SortableTh.vue?4df8aaa5